"use client";

import { UserData } from "@/types/types";
import React, { createContext, useContext, useState } from "react";

export interface UserAuthDataContextType {
  userData: UserData;
  setUserData: (userData: UserData) => void;
}

const UserAuthDataContext: React.Context<UserAuthDataContextType | null> =
  createContext<UserAuthDataContextType | null>(null);

export function UserAuthDataContextWrapper({
  children,
  initialState,
}: {
  children: React.ReactNode;
  initialState: UserData;
}) {
  const [userData, setUserData] = useState(initialState);
  return (
    <UserAuthDataContext.Provider
      value={{
        userData: userData,
        setUserData: setUserData,
      }}
    >
      {children}
    </UserAuthDataContext.Provider>
  );
}

export function useUserAuthDataContext() {
  const context = useContext(UserAuthDataContext);
  if (!context) {
    throw new Error("Unable to use context for user auth data");
  }
  return context;
}
